import { create } from 'zustand';
import { adminOrganizationManagementApi } from '@api/api-config.ts';
import { AdminOrganizationListResponse } from '@api/generated/portal-be-admin';

export type OrganizationType = 'SUPPLIER' | 'CLIENT';

export interface OrganizationFilters {
  q?: string;
  type?: OrganizationType;
  page: number;
  size: number;
}

interface PaginationInfo {
  page: number;
  size: number;
  total: number;
  totalPages: number;
  hasPrev: boolean;
  hasNext: boolean;
}

interface AdminOrganizationStoreState {
  loading: boolean;
  error: string | null;
  data: AdminOrganizationListResponse[] | null;
  pagination: PaginationInfo | null;
  loadOrganizations: (filters: OrganizationFilters) => Promise<void>;
}

export const useAdminOrganizationStore = create<AdminOrganizationStoreState>(set => ({
  loading: false,
  error: null,
  data: null,
  pagination: null,

  loadOrganizations: async (filters: OrganizationFilters) => {
    try {
      set({ loading: true, error: null });
      const response = await adminOrganizationManagementApi.getAdminOrganizations({
        page: filters.page,
        size: filters.size,
        q: filters.q,
        type: filters.type,
      });
      const result = response.data;
      set({
        loading: false,
        error: null,
        data: result.items || [],
        pagination: {
          page: result.page,
          size: result.size,
          total: result.total,
          totalPages: result.totalPages,
          hasPrev: result.hasPrev,
          hasNext: result.hasNext,
        },
      });
    } catch (error) {
      set({
        loading: false,
        error: error instanceof Error ? error.message : 'Chyba při načítání organizací',
      });
    }
  },
}));
